import { Avatar, Button, Flex, Space, Tag, Typography } from "antd";
import { ScheduleOutlined, EditOutlined } from "@ant-design/icons";
import { useNavigate } from "react-router-dom";
import EllipsisText from "components/EllipsisText";
import { getIssueStatusLabel } from "helpers/options/issue_statuses";
import { useCalendarIssues } from "components/CalendarIssues/context";
import formatPhone from "helpers/phone_formatter";
import getIssueType from "helpers/issue_types";

const IssueItem = ({ close, ...issue }) => {
  const navigate = useNavigate();
  const { setCalendarIssueId } = useCalendarIssues();
  const type = getIssueType(issue.issue_type);
  return (
    <div className="calendar-viewer__item" key={issue.id}>
      {issue.worker?.id && (
        <>
          <Space style={{ marginBottom: 10 }}>
            <Avatar
              style={{
                backgroundColor: issue.worker?.color,
              }}
            >
              {issue.worker.initials}
            </Avatar>
            <Typography.Text delete={issue.worker?.is_deleted}>
              <EllipsisText text={issue.worker.full_name} limit={30} />
            </Typography.Text>
          </Space>
          <br />
        </>
      )}
      <Flex gap={5} style={{ marginBottom: 5 }}>
        {getIssueStatusLabel(issue.status)}
        <Tag color={type.color}>{type.label}</Tag>
      </Flex>
      <Typography.Text strong>
        {issue.client_street} {issue.client_building_number}/
        {issue.client_apartment_number}
      </Typography.Text>
      <br />
      <Typography.Text strong>
        {issue.client_post_code} {issue.client_city}
      </Typography.Text>
      <br />
      <Typography.Text strong>
        {formatPhone(issue.client_phone)}
      </Typography.Text>
      <br />
      <Flex justify="flex-end" gap={10} style={{ marginTop: 10 }}>
        <Button
          onClick={() => {
            setCalendarIssueId(issue.id);
            close();
          }}
          type="primary"
          ghost
          icon={<ScheduleOutlined />}
        >
          Przenieś
        </Button>
        <Button
          onClick={() => {
            navigate(`/issues/${issue.id}`);
            window.scrollTo(0, 0);
          }}
          type="primary"
          ghost
          icon={<EditOutlined />}
        >
          Edytuj
        </Button>
      </Flex>
    </div>
  );
};

export default IssueItem;
